import type { AIDevGovernanceRow } from '../../masterdevelopment/framework';

type Props = { items?: AIDevGovernanceRow[] };

export function AIDevGovernancePanel({ items = [] }: Props) {
  return (
    <div className="space-y-2">
      {items.map((item) => (
        <div key={item.requirement} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between gap-3">
            <p className="text-sm font-medium">{item.requirement}</p>
            <span className="shrink-0 text-sm font-semibold text-brand-600">{item.score}%</span>
          </div>
          <p className="mt-1 text-xs font-medium text-emerald-600">{item.status}</p>
        </div>
      ))}
    </div>
  );
}
